import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { ImageSuiteApps } from "../../../Helper";
import { ImageSuitApps } from "../../../Helper";
import { ImageSuiteSidebar } from "./ImageSuiteSidebar";
import { ImageSuiteContainer } from "./ImageSuiteContainer";
import { ImageRestoreIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/ImageRestoreIcon";
import { BgRemoverIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/BgRemoverIcon";
import { GenerateIllsturationsIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/GenerateIllsturationsIcon";
import { GenerateIconIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/GenerateIconIcon";
import { GenerateLogoIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/GenerateLogoIcon";
import { GenerateImgIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/GenerateImgIcon";
import { userGetImageSuiteSamples } from "../../../store/Apis/SuitesApps/ImageSuitesApi";
import { TinyFigureIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/TinyFigureIcon";
import { MicroPeopleIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/MIcroPeopleIcon";
import { ImageToImageIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/ImageToImageIcon";
import "./ImageSuites.css";
import { Compare } from "@mui/icons-material";

export const ImageSuitesNavbarApps = [
  {
    title: ImageSuiteApps.ImageGenerator,
    icon: <GenerateImgIcon className="text-nav-item-icon" />,
    type: ImageSuitApps.ImageGenerator,
  },
  {
    title: ImageSuiteApps.ImageToImage,
    icon: <Compare
            className="text-nav-item-icon"
            sx={{
              width: "15px",
              height: "15px",
            }}
         />,
    type: ImageSuitApps.ImageToImage,
  },
  {
    title: ImageSuiteApps.LogoGenerator,
    icon: <GenerateLogoIcon className="text-nav-item-icon" />,
    type: ImageSuitApps.LogoGenerator,
  },
  {
    title: ImageSuiteApps.IconGenerator,
    icon: <GenerateIconIcon className="text-nav-item-icon" />,
    type: ImageSuitApps.IconGenerator,
  },
  {
    title: ImageSuiteApps.MicroPeople,
    icon: <MicroPeopleIcon className="hidden-menu-app-icon" />,
    type: ImageSuitApps.MicroPeople,
  },
  {
    title: ImageSuiteApps.TinyFigures,
    icon: <TinyFigureIcon className="hidden-menu-app-icon" />,
    type: ImageSuitApps.TinyFigures,
  },
  {
    title: ImageSuiteApps.IllustrationGenerator,
    icon: <GenerateIllsturationsIcon className="text-nav-item-icon" />,
    type: ImageSuitApps.IllustrationGenerator,
  },
  {
    title: ImageSuiteApps.BackgroundRemover,
    icon: <BgRemoverIcon className="text-nav-item-icon-stroke" />,
    type: ImageSuitApps.BackGroundRemover,
  },
  {
    title: ImageSuiteApps.ImageRestore,
    icon: <ImageRestoreIcon className="text-nav-item-icon" />,
    type: ImageSuitApps.ImageRestore,
  },
];

export const GetAppObject = (title: string) => {
  const appObject = ImageSuitesNavbarApps.find((app) => app.title === title);
  return appObject;
};

export const ImageSuite = () => {
  const defaultApp = ImageSuitesNavbarApps[0];
  const [activeItem, setActiveItem] = useState(defaultApp);
  const { refetch: GetSamplesImageSuite, data: SamplesImageSuite } =
    userGetImageSuiteSamples();

  useEffect(() => {
    GetSamplesImageSuite();
  }, []);

  return (
    <Box className="image-suites-view">
      <ImageSuiteSidebar
        setActiveItem={setActiveItem}
        activeItem={activeItem}
        TextSuitesApps={ImageSuitesNavbarApps}
      />
      <ImageSuiteContainer
        activeItem={activeItem}
        ImageSuiteSamples={SamplesImageSuite}
      />
    </Box>
  );
};
